import AuthErrorView from './AuthErrorView';
import LoadingScreen from './LoadingScreen';
import { useAuth0 } from '@auth0/auth0-react';

function HandleAuth() {
    const { isLoading, error, loginWithRedirect } = useAuth0();

    if (error)
        return (
            <AuthErrorView
                error={error}
                loginWithRedirect={loginWithRedirect}
            />
        );

    return (
        <LoadingScreen>
            <h3 style={{ textAlign: 'center' }}>
                {isLoading ? 'Authenticating...' : 'Redirecting...'}
            </h3>
        </LoadingScreen>
    );
}

export default HandleAuth;
